@if (showButton()) {
<div class="load-more-results" data-testid="load-more-results">
  <goab-button
    type="primary"
    [width]="buttonWidthVar()"
    [disabled]="isLoadingInitial()"
    [attr.aria-busy]="isLoadingInitial()"
    data-testid="load-more-button"
    (onClick)="handleButtonClick()"
  >
    <span class="load-more-button__labels">
      <span
        class="load-more-button__label"
        [class.load-more-button__label--hidden]="isLoadingInitial()"
      >
        <span class="load-more-button__label-content" #idleLabelContent>{{
          buttonLabel()
        }}</span>
      </span>
      <span
        class="load-more-button__label load-more-button__label--loading"
        [class.load-more-button__label--hidden]="!isLoadingInitial()"
      >
        <span class="load-more-button__label-content" #loadingLabelContent>
          <span class="load-more-button__spinner" aria-hidden="true"></span>
          Loading more {{ itemLabelPlural() }}
        </span>
      </span>
    </span>
  </goab-button>
  <goab-text
    size="body-s"
    tag="p"
    color="secondary"
    mt="m"
    mb="none"
    data-testid="load-more-summary"
  >
    {{ summaryText() }}
  </goab-text>
</div>
} @else {
<div
  class="load-more-results load-more-results--summary-only"
  data-testid="load-more-results"
>
  <goab-text
    size="body-s"
    tag="p"
    color="secondary"
    mt="none"
    mb="none"
    data-testid="load-more-summary"
  >
    {{ summaryText() }}
  </goab-text>
</div>
}
